import { RouteComponentProps } from 'react-router-dom';
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Permission, AnalysisSet } from "../../misc/api/apiTypes";
import { DlcoAnalysisSet, FvcAnalysisSet, SvcAnalysisSet, LungVolumeAnalysisSet, PefAnalysisSet, OscillometryAnalysisSet } from "webportalclient";

export type UseHistoryType = RouteComponentProps['history'];

export const GoBackToList = (history: UseHistoryType, currentUserPermissions: Permission[], sessionListRoute: string, analysisPermission: PermissionEnum, analysisListRoute: string) => {
    currentUserPermissions.map(p => p.Id).includes(analysisPermission) ? history.push(analysisListRoute) : history.push(sessionListRoute);
}

export const createFormatters = <T extends DlcoAnalysisSet | FvcAnalysisSet | SvcAnalysisSet | LungVolumeAnalysisSet | PefAnalysisSet | OscillometryAnalysisSet>(
    isQcAnalysisSet: (set: T) => boolean
) => {
    const formatValue = (getter: (set: T) => string) => (set: T) =>
        isQcAnalysisSet(set) ? "-" : getter(set);

    return {
        formatSiteId: formatValue(set => set.session.visit.subject.site.number),
        formatSubjectId: formatValue(set => set.session.visit.subject.number),
        formatSubjectType: formatValue(set => set.session.visit.subject.typeName),
        formatVisitLabel: formatValue(set => set.session.visit.name),
        formatSessionLabel: formatValue(set => set.session.name),
    };
};
